import React, { FC, ReactNode } from "react";
import "./button.css";

interface ButtonProps {
  children: ReactNode;

  /**
   * Simple click handler
   */
  onClick?: () => void;
  className?: string;
  type?: "submit" | "reset" | "button" | undefined;
  disabled?: boolean;
  loading?: boolean;
}

/**
 * The world's most _basic_ button
 */
export const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  type = "button",
  disabled = false,
  loading,
}) => (
  <button
    className={`Button ${className || ""}`}
    onClick={onClick}
    type={type}
    disabled={disabled}
  >
    {loading ? <Spinner /> : children}
  </button>
);

const Spinner = () => (
  <div className="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);
